import Vue from 'vue';
import Router from 'vue-router';
import startCase from 'lodash/startCase';

import store from '@/store';

import Home from './views/layouts/Home.vue';
import Landing from './views/layouts/Landing.vue';

import login from './views/login.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {
          path: '/admin/:service?/:id?',
          name: 'admin',
          component: () => import(/* webpackChunkName: "admin" */ './views/Admin.vue'),
          meta: { perms: ['admin'] },
        },
        {
          path: '/clinic/:id?',
          name: 'clinic',
          component: () => import(/* webpackChunkName: "clinic" */ './views/Clinic.vue'),
          meta: { perms: ['student'] },
        },
        {
          path: '/grading/:id?',
          name: 'grading',
          component: () => import(/* webpackChunkName: "clinic" */ './views/Clinic.vue'),
          meta: { perms: ['staff', 'admin'] },
        },
        {
          path: '/history/:id?',
          name: 'history',
          component: () => import(/* webpackChunkName: "history" */ './views/History.vue'),
        },
        {
          path: '/',
          name: 'results/',
          component: () => import(/* webpackChunkName: "results" */ './views/Results.vue'),
        },
      ],
    },
    {
      path: '/',
      component: Landing,
      children: [
        {
          path: '/login/',
          name: 'Login',
          component: login,
          meta: { isPublic: true },
        },
        {
          path: '/logout/',
          name: 'Logout',
          component: login,
          meta: { isPublic: true },
        },
      ],
    },
    { path: '*', redirect: '/' },
  ],
});

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => !!record.meta.isPublic);
  const perms = to.matched.reduce((a, record) => [...a, ...(record.meta.perms || [])], []);
  if (to.path === '/logout') {
    // eslint-disable-next-line no-console
    return store.dispatch('auth/logout').catch(console.error).then(() => next({ path: '/login' }));
  }
  if (isPublic && store.state.auth.user) {
    return next({ path: '/' });
  }
  if (!isPublic && !store.state.auth.user) {
    return next({
      path: '/login',
      query: to.path === '/' ? {} : { followPath: to.path },
    });
  }
  if (store.state.auth.user) {
    if (perms.length && perms.indexOf(store.state.auth.user.perm) === -1) return next('/');
    document.title = `COEUS - ${startCase(store.state.auth.user.name)}`;
  } else {
    document.title = 'COEUS - Login';
  }
  if (window.updatedWinTitle) window.updatedWinTitle();
  return next();
});

export default router;
